import { Button, Group, Iframe, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useTheme } from "@/comn/hooks";
import { APIS, SF_EWC_SRCH } from "@/tra/tancis/ptli/temp/dw/services/TdwiDwService";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

/*
 * DW Iframe Page
 * !== DW Ifame Page ==!
 */
export const EWCI1001010Q = () => {
    const { menuId } = usePage();
    const modal = useModal();
    const { t } = useTranslation();
    const ewacsOptions: any = [
        {
            label: "ECTS(Consumer) Monitoring",
            value: `${process.env.REACT_APP_GRAFANA_EWCI1001010Q_ECTSMONITORING}`,
        },
    ];

    const [iframeSrc, setIframeSrc] = useState("");

    const handler = {
        handleChange: (v: any) => {
            setIframeSrc(v);
        },
    };

    // useEffect(() => {}, []);
    useEffect(() => {
        setIframeSrc(ewacsOptions[0].value);
    }, []);

    return (
        <Page>
            {iframeSrc && (
                <Group>
                    <Group.Body>
                        <Iframe src={iframeSrc} height={800} />
                    </Group.Body>
                </Group>
            )}
        </Page>
    );
};
